
import { updateAppConfig } from '#app'
import { defuFn } from '/var/jenkins_home/workspace/qboson-web/node_modules/.pnpm/defu@6.1.4/node_modules/defu/dist/defu.mjs'

const inlineConfig = {
  "nuxt": {
    "buildId": "f777b2fb-a738-421c-87ce-9815ea2978e6"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}

import cfg0 from "/var/jenkins_home/workspace/qboson-web/app/app.config.ts"
import cfg1 from "/var/jenkins_home/workspace/qboson-web/app.config.ts"

export default /* #__PURE__ */ defuFn(cfg0, cfg1, inlineConfig)
